export default __webpack_public_path__ + "static/media/product_4.2.e82e43e0.jpg";